import React, { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { SEO } from '../components/shared/SEO';
import { Header } from '../components/layout/Header';
import { AnnouncementBar } from '../components/layout/AnnouncementBar';
import { MobileDeliverToPill } from '../components/layout/MobileDeliverToPill';
import { Footer } from '../components/layout/Footer';
import { MobileFooterNav } from '../components/layout/MobileFooterNav';
import { PharmacistChat } from '../components/services/PharmacistChat';
import { PageHeroBreadcrumb } from '../components/layout/PageHeroBreadcrumb';
import { MobileInternalHeader } from '../components/layout/MobileInternalHeader';
import { LocationModal } from '../components/modals/LocationModal';
import { PrescriptionDetailsModal } from '../components/prescription/PrescriptionDetailsModal';
import { PrescriptionSuccessModal } from '../components/prescription/PrescriptionSuccessModal';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { trackPrescriptionCashOrder, trackPrescriptionInsuranceOrder, trackPrescriptionWasfatyOrder, trackPrescriptionPageView } from '../lib/analytics/events';
import { MapPinIcon, EditIcon, FileTextIcon, ImageIcon, CreditCardIcon, WalletIcon, BanknoteIcon, CheckCircleIcon, ClockIcon, TruckIcon, XCircleIcon, PackageIcon, ChevronRightIcon, HomeIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../data/productImages';
export function PrescriptionPage() {
  const navigate = useNavigate();
  const [selectedPrescriptionType, setSelectedPrescriptionType] = useState('');
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [selectedOutOfStock, setSelectedOutOfStock] = useState('');
  const [prescriptionDetails, setPrescriptionDetails] = useState('');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedPrescription, setSelectedPrescription] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [wasfatyCustomerName, setWasfatyCustomerName] = useState('');
  const [wasfatyNationalId, setWasfatyNationalId] = useState('');
  const [wasfatyNumber, setWasfatyNumber] = useState('');
  const [insuranceCustomerName, setInsuranceCustomerName] = useState('');
  const [insuranceNationalId, setInsuranceNationalId] = useState('');
  const [insuranceProvider, setInsuranceProvider] = useState('');
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<{
    name: string;
  } | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const recentPrescriptions = [{
    id: '#RX-2025-00123',
    date: '2024-01-15',
    status: 'delivered',
    items: [{
      name: 'Metformin 500mg',
      quantity: 60,
      price: 125.5,
      image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg'
    }, {
      name: 'Lisinopril 10mg',
      quantity: 30,
      price: 120.0,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg'
    }],
    doctor: 'Dr. Sarah Ahmed',
    deliveryAddress: 'Riyadh, Al Malqa District, King Fahd Road, Building 123, Apartment 456',
    deliveryCoordinates: {
      lat: 24.7136,
      lng: 46.6753
    },
    paymentMethod: 'Credit Card',
    total: 245.5,
    prescriptionSource: 'cash' as const,
    trackingHistory: [{
      status: 'Delivered',
      timestamp: '2024-01-15T14:30:00',
      description: 'Package delivered successfully'
    }, {
      status: 'Out for Delivery',
      timestamp: '2024-01-15T10:00:00',
      description: 'Package is out for delivery'
    }, {
      status: 'In Transit',
      timestamp: '2024-01-15T08:00:00',
      description: 'Package is in transit'
    }]
  }, {
    id: '#RX-2025-00122',
    date: '2024-01-10',
    status: 'ready',
    items: [{
      name: 'Atorvastatin 20mg',
      quantity: 30,
      price: 89.99,
      image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg'
    }],
    doctor: 'Dr. Mohammed Ali',
    pickupBranch: {
      name: 'Innova Pharmacy - Riyadh Park',
      address: 'Riyadh Park Mall, Al Malaz District, Riyadh',
      coordinates: {
        lat: 24.7136,
        lng: 46.6753
      }
    },
    pickupTime: 'Today, 2:00 PM - 6:00 PM',
    paymentMethod: 'Cash on Delivery',
    total: 89.99,
    prescriptionSource: 'wasfaty' as const,
    wasfatyNumber: 'WF-2024-001234'
  }, {
    id: '#RX-2025-00121',
    date: '2024-01-05',
    status: 'in-progress',
    items: [{
      name: 'Insulin Glargine',
      quantity: 1,
      price: 356.0,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png'
    }, {
      name: 'Test Strips',
      quantity: 100,
      price: 100.0,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg'
    }],
    doctor: 'Dr. Fatima Hassan',
    deliveryAddress: 'Riyadh, Al Malqa District, King Fahd Road',
    deliveryCoordinates: {
      lat: 24.7114,
      lng: 46.6747
    },
    paymentMethod: 'Mada',
    total: 456.0,
    prescriptionSource: 'insurance' as const,
    insuranceProvider: 'Bupa Arabia',
    trackingHistory: [{
      status: 'Processing',
      timestamp: '2024-01-05T14:00:00',
      description: 'Prescription received and under review'
    }]
  }];
  const isFormValid = () => {
    const baseValid = selectedPrescriptionType && (prescriptionDetails || selectedFile) && selectedPaymentMethod && selectedOutOfStock;
    if (!baseValid) return false;
    if (selectedPrescriptionType === 'wasfaty') {
      return wasfatyCustomerName && wasfatyNationalId && wasfatyNumber;
    }
    if (selectedPrescriptionType === 'insurance') {
      return insuranceCustomerName && insuranceNationalId && insuranceProvider;
    }
    return true;
  };
  // Determine next required step (label + section id to scroll to)
  const getNextRequiredStep = (): {
    label: string;
    sectionId: string;
  } | null => {
    if (!selectedPrescriptionType) {
      return {
        label: 'Select Prescription Type',
        sectionId: 'section-prescription-type'
      };
    }
    if (selectedPrescriptionType === 'wasfaty') {
      if (!wasfatyCustomerName || !wasfatyNationalId || !wasfatyNumber) {
        return {
          label: 'Complete Wasfaty Information',
          sectionId: 'section-prescription-type'
        };
      }
    }
    if (selectedPrescriptionType === 'insurance') {
      if (!insuranceCustomerName || !insuranceNationalId || !insuranceProvider) {
        return {
          label: 'Complete Insurance Information',
          sectionId: 'section-prescription-type'
        };
      }
    }
    if (!prescriptionDetails && !selectedFile) {
      return {
        label: 'Upload Prescription',
        sectionId: 'section-upload'
      };
    }
    if (!selectedPaymentMethod) {
      return {
        label: 'Select Payment Method',
        sectionId: 'section-payment'
      };
    }
    if (!selectedOutOfStock) {
      return {
        label: 'Choose Out-of-Stock Option',
        sectionId: 'section-out-of-stock'
      };
    }
    return null;
  };
  const scrollToSection = (sectionId: string) => {
    const el = document.getElementById(sectionId);
    if (!el) return;
    const headerOffset = window.innerWidth >= 768 ? 220 : 120;
    const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
    // Add a brief highlight pulse
    el.classList.add('ring-2', 'ring-[#1E2B55]', 'ring-offset-2');
    setTimeout(() => {
      el.classList.remove('ring-2', 'ring-[#1E2B55]', 'ring-offset-2');
    }, 1500);
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'delivered':
        return <CheckCircleIcon className="w-4 h-4 text-green-500" data-id="element-7213" data-mp="kqaphuxvdqx3" />;
      case 'ready':
        return <PackageIcon className="w-4 h-4 text-blue-500" data-id="element-7214" data-mp="pp57iuo0jbg5" />;
      case 'in-progress':
        return <ClockIcon className="w-4 h-4 text-yellow-500" data-id="element-7215" data-mp="uiq72r598dhg" />;
      default:
        return <XCircleIcon className="w-4 h-4 text-red-500" data-id="element-7216" data-mp="zfq3eacay1vd" />;
    }
  };
  const getStatusText = (status: string) => {
    switch (status) {
      case 'delivered':
        return 'Delivered';
      case 'ready':
        return 'Ready';
      case 'in-progress':
        return 'In Progress';
      default:
        return 'Rejected';
    }
  };
  const handlePrescriptionClick = (prescription: any) => {
    setSelectedPrescription(prescription);
    setIsModalOpen(true);
  };
  const handleViewAllClick = () => {
    navigate('/prescription/history');
  };
  const handleViewHistoryClick = () => {
    // Track analytics
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('event', 'prescription_history_click', {
        page: 'prescription',
        device: 'mobile'
      });
    }
    navigate('/prescription/history');
  };
  // Track prescription page view on mount
  useEffect(() => {
    if (selectedPrescriptionType) {
      trackPrescriptionPageView(selectedPrescriptionType as 'cash' | 'insurance' | 'wasfaty', 'start');
    }
  }, [selectedPrescriptionType]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isFormValid()) {
      toast.error('Please complete all required fields', {
        duration: 5000
      });
      return;
    }
    if (!selectedFile && !prescriptionDetails) {
      toast.error('Please upload prescription file or enter details', {
        duration: 5000
      });
      return;
    }
    setIsSubmitting(true);
    // Track analytics based on prescription type
    if (selectedPrescriptionType === 'cash') {
      trackPrescriptionCashOrder();
    } else if (selectedPrescriptionType === 'insurance') {
      trackPrescriptionInsuranceOrder();
    } else if (selectedPrescriptionType === 'wasfaty') {
      trackPrescriptionWasfatyOrder();
    }
    // Show success modal immediately
    setShowSuccessModal(true);
    setIsSubmitting(false);
    // Navigate to prescriptions history after modal closes
    setTimeout(() => {
      navigate('/prescription/history');
    }, 2500);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-7217" data-mp="1vuz06sqifefj">
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-7218" data-mp="1qvmfadj78hfl">
        {/* Desktop Header */}
        <div className="hidden md:block" data-id="element-7219" data-mp="2ah4qq3d3adk1">
          <Header locationModalOpen={locationModalOpen} setLocationModalOpen={setLocationModalOpen} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} showAnnouncement={true} data-id="element-7220" data-mp="2ai6105ma6w0p" />
        </div>
        <main className="flex-grow pt-[var(--header-height-mobile)] md:pt-[var(--header-height-desktop)]" data-id="element-7221" data-mp="25ha0m2151s01">
          <h1 className="sr-only" data-id="element-7222" data-mp="1rplnpwj2ezi0">
            Upload Your Prescription - Fast & Secure Medicine Delivery
          </h1>
          {/* Mobile Header Overlay */}
          <MobileInternalHeader title="Prescription Services" data-id="element-7223" data-mp="1hsgy1mq0glwg" />
          {/* Page Hero Breadcrumb */}
          <PageHeroBreadcrumb breadcrumbs={[{
          label: 'Home',
          href: '/'
        }, {
          label: 'Prescription Services'
        }]} title="Prescription Services" description="Upload your prescription and get your medications delivered quickly and securely." data-id="element-7224" data-mp="1mraffq8f4x1w" />
          <div className="container mx-auto px-4 md:px-8 lg:px-12 py-8" data-id="element-7225" data-mp="3apkvimpr6lq4">
            {/* View Prescription History Button - Mobile Only */}
            <div className="md:hidden mb-6" data-id="element-7226" data-mp="35qrjkyq472s2">
              <button onClick={handleViewHistoryClick} className="w-full bg-white border-2 border-[#1E2B55] text-[#1E2B55] font-bold py-3 px-4 rounded-lg hover:bg-[#1E2B55] hover:text-white transition-all flex items-center justify-center gap-2" aria-label="Open prescription history" data-id="element-7227" data-mp="31ompjyvr844w">
                <FileTextIcon className="w-5 h-5" data-id="element-7228" data-mp="3pcwcj44pexxm" />
                View Prescription History
              </button>
            </div>
            <div className="flex flex-col lg:flex-row gap-6" data-id="element-7229" data-mp="3khgx47r1stz3">
              {/* Sidebar */}
              <div className="lg:w-80 flex-shrink-0 space-y-6" data-id="element-7230" data-mp="2dwz96aw4cbgv">
                {/* How It Works */}
                <div className="bg-white rounded-xl shadow-md p-6 sticky top-24 hidden md:block" data-id="element-7231" data-mp="2921zd1r0ly2x">
                  <h3 className="text-xl font-bold mb-6 text-center" data-id="element-7232" data-mp="ofu0kxi5hym3">
                    How It Works
                  </h3>
                  <div className="space-y-6" data-id="element-7233" data-mp="xiv2sn3wb5kh">
                    <div className="flex items-start" data-id="element-7234" data-mp="xh1wj8x72nd0">
                      <div className="bg-[#1E2B55] text-white w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 font-bold" data-id="element-7235" data-mp="129uzbr93rlmg">
                        1
                      </div>
                      <div className="ml-4" data-id="element-7236" data-mp="1c6zolzy8vx7h">
                        <h4 className="font-bold mb-1 text-sm" data-id="element-7237" data-mp="1c5y0ouw4rg8c">
                          Upload Prescription
                        </h4>
                        <p className="text-xs text-gray-600" data-id="element-7238" data-mp="1l877b9oa2pgg">
                          Take a clear photo or scan your prescription
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-7239" data-mp="3mz0twgwoo6xy">
                      <div className="bg-[#1E2B55] text-white w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 font-bold" data-id="element-7240" data-mp="3mzu1tl7dp2ho">
                        2
                      </div>
                      <div className="ml-4" data-id="element-7241" data-mp="2nniuquq5oxyy">
                        <h4 className="font-bold mb-1 text-sm" data-id="element-7242" data-mp="31o3atj4osfor">Verification</h4>
                        <p className="text-xs text-gray-600" data-id="element-7243" data-mp="2wogxzasrt1gh">
                          Our pharmacist reviews and verifies your prescription
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-7244" data-mp="240baigac0ycy">
                      <div className="bg-[#1E2B55] text-white w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 font-bold" data-id="element-7245" data-mp="23xqa7vpomqhb">
                        3
                      </div>
                      <div className="ml-4" data-id="element-7246" data-mp="2dvwak8vubok2">
                        <h4 className="font-bold mb-1 text-sm" data-id="element-7247" data-mp="1q7msni1qzky7">
                          Order Confirmation
                        </h4>
                        <p className="text-xs text-gray-600" data-id="element-7248" data-mp="1l91qve6ukt7n">
                          Receive confirmation and proceed to checkout
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-7249" data-mp="5k2k028xoc59">
                      <div className="bg-[#1E2B55] text-white w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 font-bold" data-id="element-7250" data-mp="3nx0c5mzhi0ov">
                        4
                      </div>
                      <div className="ml-4" data-id="element-7251" data-mp="jittfbcup9n2">
                        <h4 className="font-bold mb-1 text-sm" data-id="element-7252" data-mp="jfo1locu7tnn">Delivery</h4>
                        <p className="text-xs text-gray-600" data-id="element-7253" data-mp="ogbu6egpsijz">
                          Get your medicines delivered to your doorstep
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Recent Prescriptions */}
                <div className="bg-white rounded-xl shadow-md p-6 hidden md:block" data-id="element-7254" data-mp="2v5qhdm8aalqg">
                  <div className="flex items-center justify-between mb-4" data-id="element-7255" data-mp="3075yj37cc83k">
                    <h3 className="text-lg font-bold" data-id="element-7256" data-mp="15qfptc2gvguh">Recent Prescriptions</h3>
                    <button onClick={handleViewAllClick} className="text-xs font-medium text-[#1E2B55] hover:underline" data-id="element-7257" data-mp="10rcuwkg7ar08">
                      View All
                    </button>
                  </div>
                  <div className="space-y-3" data-id="element-7258" data-mp="rwor6yq9xhdj">
                    {recentPrescriptions.slice(0, 3).map(prescription => <button key={prescription.id} onClick={() => handlePrescriptionClick(prescription)} className="w-full border border-gray-200 rounded-lg p-3 hover:shadow-md hover:border-[#1E2B55] transition-all text-left" data-id="element-7259" data-mp="i0lgv5l9qcfi">
                        <div className="flex items-center justify-between mb-2" data-id="element-7260" data-mp="27ft8gfs4k4nv">
                          <span className="text-xs font-bold text-gray-900" data-id="element-7261" data-mp="23e7qig0qh06t">
                            {prescription.id}
                          </span>
                          <div className="flex items-center" data-id="element-7262" data-mp="3lbb2155ir1s6">
                            {getStatusIcon(prescription.status)}
                            <span className="text-xs ml-1" data-id="element-7263" data-mp="3v1cppvtymi6k">
                              {getStatusText(prescription.status)}
                            </span>
                          </div>
                        </div>
                        <p className="text-xs text-gray-600 mb-2" data-id="element-7264" data-mp="32d8hp3nx1t0p">
                          {new Date(prescription.date).toLocaleDateString()}
                        </p>
                        <div className="text-xs text-gray-500" data-id="element-7265" data-mp="37dmpqlpip2yq">
                          {prescription.items.length} item(s)
                        </div>
                      </button>)}
                  </div>
                </div>
              </div>
              {/* Main Form */}
              <div className="flex-1 space-y-6" data-id="element-7266" data-mp="vm932f5bwn0l">
                {/* Delivery/Pickup Address */}
                <div className="bg-white rounded-xl shadow-md p-6" data-id="element-7267" data-mp="79oxlf5elrrk">
                  <div className="flex items-center justify-between mb-4" data-id="element-7268" data-mp="79xc1bh6d54v">
                    <h2 className="text-xl font-bold" data-id="element-7269" data-mp="2bnit6f0gelw">
                      Delivery / Pickup Address
                    </h2>
                    <button className="flex items-center text-[#1E2B55] hover:text-[#fdc300] font-medium" data-id="element-7270" data-mp="g3adx2x7vh33">
                      <EditIcon className="w-4 h-4 mr-1" data-id="element-7271" data-mp="b965ef8az0zw" />
                      Change
                    </button>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4" data-id="element-7272" data-mp="l1lndcjlnpks">
                    <div className="flex items-start" data-id="element-7273" data-mp="z0v207s5qbmn">
                      <MapPinIcon className="w-5 h-5 text-[#1E2B55] mr-3 mt-1" data-id="element-7274" data-mp="yzjwo3j2cvtf" />
                      <div className="flex-1" data-id="element-7275" data-mp="v0b6t9r59i35">
                        <div className="flex items-center mb-2" data-id="element-7276" data-mp="uxf83j7h2pdn">
                          <span className="bg-[#1E2B55] text-white text-xs font-bold px-2 py-0.5 rounded" data-id="element-7277" data-mp="30szrlcm6owu7">
                            Home
                          </span>
                        </div>
                        <p className="text-gray-900 font-medium mb-1" data-id="element-7278" data-mp="2mn7v337t64uc">
                          Riyadh, Al Malqa District, King Fahd Road
                        </p>
                        <p className="text-gray-600 text-sm" data-id="element-7279" data-mp="2cxegruga7bme">
                          Postal Code: 12345
                        </p>
                        <p className="text-gray-600 text-sm mt-2" data-id="element-7280" data-mp="2huerwjrzn4kd">
                          Ahmed Mohammed • +966 50 123 4567
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Prescription Type */}
                <div id="section-prescription-type" className="bg-white rounded-xl shadow-md p-6 transition-all scroll-mt-32" data-id="element-7281" data-mp="1tzbxzxebuax1">
                  <h2 className="text-xl font-bold mb-4" data-id="element-7282" data-mp="3od378vsqusry">Prescription Type</h2>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-7283" data-mp="3tbo8myjqfihz">
                    {[{
                    id: 'cash',
                    label: 'Cash Prescription',
                    icon: BanknoteIcon
                  }, {
                    id: 'wasfaty',
                    label: 'Wasfaty',
                    icon: FileTextIcon
                  }, {
                    id: 'insurance',
                    label: 'Insurance',
                    icon: WalletIcon
                  }].map(type => <button key={type.id} onClick={() => setSelectedPrescriptionType(type.id)} className={`border-2 rounded-lg p-4 text-center transition-all ${selectedPrescriptionType === type.id ? 'border-[#1E2B55] bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-7284" data-mp="1od51vcjgases">
                        <type.icon className={`w-8 h-8 mx-auto mb-2 ${selectedPrescriptionType === type.id ? 'text-[#1E2B55]' : 'text-gray-400'}`} data-id="element-7285" data-mp="33prljlt3ozv" />
                        <span className="text-sm font-medium" data-id="element-7286" data-mp="3moex0x5iruja">
                          {type.label}
                        </span>
                      </button>)}
                  </div>
                  {/* Wasfaty Additional Fields */}
                  {selectedPrescriptionType === 'wasfaty' && <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-7287" data-mp="38v76l8t6d536">
                      <h3 className="text-sm font-bold text-gray-900 mb-4" data-id="element-7288" data-mp="33wcf7ih5687g">
                        Wasfaty Information
                      </h3>
                      <div className="space-y-4" data-id="element-7289" data-mp="3dwd038unswdr">
                        <div data-id="element-7290" data-mp="3dujttunyke6a">
                          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7291" data-mp="2q6shir2f4150">
                            Customer Name{' '}
                            <span className="text-red-500" data-id="element-7292" data-mp="2l764ahmlakw7">*</span>
                          </label>
                          <input type="text" value={wasfatyCustomerName} onChange={e => setWasfatyCustomerName(e.target.value)} placeholder="Enter customer name" className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-7293" data-mp="3avbjfe0tfz9g" />
                        </div>
                        <div data-id="element-7294" data-mp="30y6uj6fl5poy">
                          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7295" data-mp="30wvpl3aembw9">
                            National ID <span className="text-red-500" data-id="element-7296" data-mp="35xt7deri53x8">*</span>
                          </label>
                          <input type="text" value={wasfatyNationalId} onChange={e => setWasfatyNationalId(e.target.value)} placeholder="Enter national ID" className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-7297" data-mp="g6wl53skikye" />
                        </div>
                        <div data-id="element-7298" data-mp="1myc3869t2y72">
                          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7299" data-mp="1myluryai1dev">
                            Wasfaty Number{' '}
                            <span className="text-red-500" data-id="element-7300" data-mp="1hxxv6o87fo91">*</span>
                          </label>
                          <input type="text" value={wasfatyNumber} onChange={e => setWasfatyNumber(e.target.value)} placeholder="Enter Wasfaty number" className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-7301" data-mp="1d0efdjvuz3ez" />
                        </div>
                      </div>
                    </div>}
                  {/* Insurance Additional Fields */}
                  {selectedPrescriptionType === 'insurance' && <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-7302" data-mp="35fe0s3rvdn6n">
                      <h3 className="text-sm font-bold text-gray-900 mb-4" data-id="element-7303" data-mp="2ro96lh79tn3p">
                        Insurance Information
                      </h3>
                      <div className="space-y-4" data-id="element-7304" data-mp="2whtvmjqvz6qr">
                        <div data-id="element-7305" data-mp="2hsfnfez1qvcy">
                          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7306" data-mp="2hp07k9xjtiah">
                            Customer Name{' '}
                            <span className="text-red-500" data-id="element-7307" data-mp="28pwnp3qk4yux">*</span>
                          </label>
                          <input type="text" value={insuranceCustomerName} onChange={e => setInsuranceCustomerName(e.target.value)} placeholder="Enter customer name" className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-7308" data-mp="2csjhha6sgtur" />
                        </div>
                        <div data-id="element-7309" data-mp="2d0h80k5jm16b">
                          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7310" data-mp="283qsbxxnh7lf">
                            National ID <span className="text-red-500" data-id="element-7311" data-mp="2lvf583fq403g">*</span>
                          </label>
                          <input type="text" value={insuranceNationalId} onChange={e => setInsuranceNationalId(e.target.value)} placeholder="Enter national ID" className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-7312" data-mp="2hss9vsjufx1i" />
                        </div>
                        <div data-id="element-7313" data-mp="1xfxsomlfqiaf">
                          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7314" data-mp="227z302z1lyxt">
                            Insurance Provider{' '}
                            <span className="text-red-500" data-id="element-7315" data-mp="276a8k1ib1na8">*</span>
                          </label>
                          <select value={insuranceProvider} onChange={e => setInsuranceProvider(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-7316" data-mp="2c4tvo58mx546">
                            <option value="" data-id="element-7317" data-mp="qt28weo04jjl">Select insurance provider</option>
                            <option value="bupa" data-id="element-7318" data-mp="ja2qocca0y1t">Bupa Arabia</option>
                            <option value="tawuniya" data-id="element-7319" data-mp="ei2k411pb6w9">Tawuniya</option>
                            <option value="medgulf" data-id="element-7320" data-mp="egrk8cbdmjaf">MedGulf</option>
                            <option value="alrajhi" data-id="element-7321" data-mp="9k0zhbommzio">Al Rajhi Takaful</option>
                            <option value="saico" data-id="element-7322" data-mp="4lfznddaehur">SAICO</option>
                            <option value="other" data-id="element-7323" data-mp="127ww6ge74rfg">Other</option>
                          </select>
                        </div>
                      </div>
                    </div>}
                </div>
                {/* Upload Prescription */}
                <div id="section-upload" className="bg-white rounded-xl shadow-md p-4 md:p-6 transition-all scroll-mt-32" data-id="element-7324" data-mp="s8622ftjsefw">
                  <h2 className="text-lg md:text-xl font-bold mb-4" data-id="element-7325" data-mp="3d0zqy6uedq76">
                    Upload Prescription
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-7326" data-mp="390pnb0u2vbvh">
                    {/* Prescription Image - Mobile-first */}
                    <div className="order-1" data-id="element-7327" data-mp="1gxbsi5j6e5xw">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7328" data-mp="1guz1l2vfwl8p">
                        Prescription Image
                      </label>
                      {selectedFile ?
                    // Inline preview
                    <div className="relative border-2 border-[#1E2B55] rounded-lg overflow-hidden bg-gray-50" data-id="element-7329" data-mp="1vlg3sofwff6n">
                          {selectedFile.type.startsWith('image/') ? <img src={URL.createObjectURL(selectedFile)} alt="Prescription preview" className="w-full h-48 md:h-56 object-contain bg-white" data-id="element-7330" data-mp="1lweluspsmnq1" /> : <div className="w-full h-48 md:h-56 flex flex-col items-center justify-center bg-white" data-id="element-7331" data-mp="2jc2aoce62tf2">
                              <FileTextIcon className="w-12 h-12 text-[#1E2B55] mb-2" data-id="element-7332" data-mp="2spat7npy0o9l" />
                              <p className="text-sm font-medium text-gray-900 px-4 text-center break-all" data-id="element-7333" data-mp="2opk6bv3jesac">
                                {selectedFile.name}
                              </p>
                              <p className="text-xs text-gray-500 mt-1" data-id="element-7334" data-mp="2xgki2m3o3nkf">
                                {(selectedFile.size / 1024).toFixed(0)} KB
                              </p>
                            </div>}
                          <button onClick={() => setSelectedFile(null)} className="absolute top-2 right-2 bg-white/95 hover:bg-white text-red-600 rounded-full p-1.5 shadow-md transition-all" aria-label="Remove file" data-id="element-7335" data-mp="25rhel8jluh8u">
                            <XCircleIcon className="w-5 h-5" data-id="element-7336" data-mp="3v6npkd2byphy" />
                          </button>
                          <div className="absolute bottom-2 left-2 bg-green-600 text-white text-xs font-bold px-2 py-1 rounded-full flex items-center gap-1" data-id="element-7337" data-mp="3q842uafwx9oj">
                            <CheckCircleIcon className="w-3.5 h-3.5" data-id="element-7338" data-mp="1e16905oag5st" />
                            Uploaded
                          </div>
                        </div> : <>
                          {/* Mobile: Two big action buttons */}
                          <div className="md:hidden grid grid-cols-2 gap-3" data-id="element-7339" data-mp="21qgzmubxcjt8">
                            <input type="file" accept="image/*" capture="environment" onChange={e => setSelectedFile(e.target.files?.[0] || null)} className="hidden" id="prescription-camera" data-id="element-7340" data-mp="1xpf00ce3i5qq" />
                            <label htmlFor="prescription-camera" className="flex flex-col items-center justify-center gap-2 bg-[#1E2B55] active:bg-[#162041] text-white font-semibold py-5 rounded-lg cursor-pointer transition-colors" data-id="element-7341" data-mp="2gmya7jcahueq">
                              <ImageIcon className="w-7 h-7" data-id="element-7342" data-mp="31zgs7b0x6al9" />
                              <span className="text-sm" data-id="element-7343" data-mp="31xm2ljepduau">Take Photo</span>
                            </label>
                            <input type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={e => setSelectedFile(e.target.files?.[0] || null)} className="hidden" id="prescription-upload" data-id="element-7344" data-mp="36wz151exspt9" />
                            <label htmlFor="prescription-upload" className="flex flex-col items-center justify-center gap-2 bg-white border-2 border-[#1E2B55] active:bg-blue-50 text-[#1E2B55] font-semibold py-5 rounded-lg cursor-pointer transition-colors" data-id="element-7345" data-mp="3uo4d35hraxya">
                              <FileTextIcon className="w-7 h-7" data-id="element-7346" data-mp="24dipv5gfnoah" />
                              <span className="text-sm" data-id="element-7347" data-mp="1zkzca8hqwt5o">Choose File</span>
                            </label>
                          </div>
                          {/* Desktop: Drop zone */}
                          <div className="hidden md:block border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-[#1E2B55] transition-colors" data-id="element-7348" data-mp="29bka3tplhtnj">
                            <ImageIcon className="w-12 h-12 text-gray-400 mx-auto mb-3" data-id="element-7349" data-mp="2n8fv8kj4fbjy" />
                            <p className="text-sm text-gray-600 mb-2" data-id="element-7350" data-mp="2i9mf0kcg96g3">
                              Choose file or drag and drop
                            </p>
                            <input type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={e => setSelectedFile(e.target.files?.[0] || null)} className="hidden" id="prescription-upload-desktop" data-id="element-7351" data-mp="nyzmtjwljet9" />
                            <label htmlFor="prescription-upload-desktop" className="inline-block bg-[#1E2B55] hover:bg-[#fdc300] hover:text-[#1E2B55] text-white font-medium py-2 px-4 rounded-lg cursor-pointer transition-colors" data-id="element-7352" data-mp="2us8bmzfqoe89">
                              Browse Files
                            </label>
                            <p className="text-xs text-gray-500 mt-3" data-id="element-7353" data-mp="2bxjm9l4h0ce7">
                              Supported: JPG, PNG, PDF • Max 5 MB
                            </p>
                          </div>
                        </>}
                      <p className="text-[11px] text-gray-500 mt-2 md:hidden" data-id="element-7354" data-mp="3hj3u8160h6ui">
                        JPG, PNG, PDF • Max 5 MB
                      </p>
                    </div>
                    {/* Prescription Details */}
                    <div className="order-2" data-id="element-7355" data-mp="37j349wdmzshc">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7356" data-mp="32ltjiu1704zu">
                        Prescription Details{' '}
                        <span className="text-gray-400 font-normal" data-id="element-7357" data-mp="2ykric7nptiv8">
                          (optional)
                        </span>
                      </label>
                      <textarea value={prescriptionDetails} onChange={e => setPrescriptionDetails(e.target.value)} placeholder="Medication names, dosage, quantity…" rows={4} className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent text-base" data-id="element-7358" data-mp="2otwtcvj34563" />
                    </div>
                  </div>
                </div>
                {/* Payment Method */}
                <div id="section-payment" className="bg-white rounded-xl shadow-md p-6 transition-all scroll-mt-32" data-id="element-7359" data-mp="ufsrt2x6vrep">
                  <h2 className="text-xl font-bold mb-4" data-id="element-7360" data-mp="14bm0ucbp92rq">
                    Select Payment Method
                  </h2>
                  <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-7361" data-mp="6mandrqzjqid">
                    {[{
                    id: 'paytabs',
                    label: 'PayTabs / Tabby'
                  }, {
                    id: 'mada',
                    label: 'Mada'
                  }, {
                    id: 'stcpay',
                    label: 'STCPay'
                  }, {
                    id: 'credit-card',
                    label: 'Credit Card'
                  }, {
                    id: 'cash',
                    label: 'Cash on Delivery'
                  }].map(method => <button key={method.id} onClick={() => setSelectedPaymentMethod(method.id)} className={`border-2 rounded-lg p-4 text-center transition-all ${selectedPaymentMethod === method.id ? 'border-[#1E2B55] bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-7362" data-mp="3qtb5t7bwf4ia">
                        <CreditCardIcon className={`w-8 h-8 mx-auto mb-2 ${selectedPaymentMethod === method.id ? 'text-[#1E2B55]' : 'text-gray-400'}`} data-id="element-7363" data-mp="382jz6djaps7l" />
                        <span className="text-sm font-medium" data-id="element-7364" data-mp="n8wznagd96sw">
                          {method.label}
                        </span>
                      </button>)}
                  </div>
                </div>
                {/* Out-of-Stock Handling */}
                <div id="section-out-of-stock" className="bg-white rounded-xl shadow-md p-6 transition-all scroll-mt-32" data-id="element-7365" data-mp="259fxnnh5njpp">
                  <h2 className="text-xl font-bold mb-4" data-id="element-7366" data-mp="1w76lyua5hkaq">
                    If the product is not available
                  </h2>
                  <div className="space-y-3" data-id="element-7367" data-mp="2jykg95rv3pyc">
                    {[{
                    id: 'contact',
                    label: 'Contact me by phone'
                  }, {
                    id: 'no-replace',
                    label: 'Do not replace missing items'
                  }, {
                    id: 'alternative',
                    label: 'Choose an alternative if available'
                  }, {
                    id: 'complete',
                    label: 'Complete my order with available items only'
                  }].map(option => <label key={option.id} className={`flex items-center p-4 border-2 rounded-lg cursor-pointer transition-all ${selectedOutOfStock === option.id ? 'border-[#1E2B55] bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-7368" data-mp="12s2jevi81bl5">
                        <input type="radio" name="out-of-stock" value={option.id} checked={selectedOutOfStock === option.id} onChange={e => setSelectedOutOfStock(e.target.value)} className="w-4 h-4 text-[#1E2B55] focus:ring-[#1E2B55]" data-id="element-7369" data-mp="1lkmxh6t9hc4w" />
                        <span className="ml-3 text-sm font-medium" data-id="element-7370" data-mp="16mo6pm6c1hg">
                          {option.label}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-xs text-gray-500 mt-4" data-id="element-7371" data-mp="2lsjyreh0uygh">
                    * Delivery charges will apply if the total is below 15 SAR.
                  </p>
                </div>
                {/* Submit / Next-Action Button (Desktop inline) */}
                {(() => {
                const nextStep = getNextRequiredStep();
                const ready = !nextStep;
                return <button onClick={e => {
                  if (isSubmitting) return;
                  if (ready) {
                    handleSubmit(e);
                  } else if (nextStep) {
                    scrollToSection(nextStep.sectionId);
                  }
                }} disabled={isSubmitting} className="hidden md:flex w-full py-4 rounded-lg font-bold text-lg transition-all bg-[#1E2B55] hover:bg-[#fdc300] hover:text-[#1E2B55] text-white items-center justify-center gap-2 disabled:opacity-70" aria-label={ready ? 'Submit prescription request' : `Go to ${nextStep!.label}`} data-id="element-7372" data-mp="34jb321m5jyo0">
                      {isSubmitting ? <>
                          <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-7373" data-mp="1d1t5t9z3d8c1">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-7374" data-mp="pd1hwusjbc52"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-7375" data-mp="33ludew6cjjx9"></path>
                          </svg>
                          Sending now
                        </> : ready ? <>
                          <CheckCircleIcon className="w-5 h-5" data-id="element-7376" data-mp="2fuoxkh0eormy" />
                          Submit Request
                        </> : <>
                          {nextStep!.label}
                          <ChevronRightIcon className="w-5 h-5" data-id="element-7377" data-mp="25vpoixbqatzf" />
                        </>}
                    </button>;
              })()}
              </div>
            </div>
          </div>
        </main>
        <div className="hidden md:block" data-id="element-7378" data-mp="1w9ey8gutdwsn">
          <Footer data-id="element-7379" data-mp="1wa7vmr7vv9y4" />
        </div>
        {/* Mobile Sticky Next-Action / Submit Button */}
        {(() => {
        const nextStep = getNextRequiredStep();
        const ready = !nextStep;
        return <div className="md:hidden fixed bottom-16 left-0 right-0 z-40 bg-white border-t border-gray-200 px-4 py-3 shadow-[0_-4px_12px_rgba(0,0,0,0.08)]" data-id="element-7380" data-mp="1mbqzlfu38557">
              <button onClick={e => {
            if (isSubmitting) return;
            if (ready) {
              handleSubmit(e as unknown as React.FormEvent);
            } else if (nextStep) {
              scrollToSection(nextStep.sectionId);
            }
          }} disabled={isSubmitting} className="w-full py-3.5 rounded-lg font-bold text-base transition-all bg-[#1E2B55] active:bg-[#162041] text-white flex items-center justify-center gap-2 disabled:opacity-70" aria-label={ready ? 'Submit prescription request' : `Go to ${nextStep!.label}`} data-id="element-7381" data-mp="2f0ftatstd86x">
                {isSubmitting ? <>
                    <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-7382" data-mp="r1vmu8mivach">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-7383" data-mp="3ukos7y55csvk"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-7384" data-mp="1oocfv1o831sf"></path>
                    </svg>
                    Sending now
                  </> : ready ? <>
                    <CheckCircleIcon className="w-5 h-5" data-id="element-7385" data-mp="2chy7gahy5x0" />
                    Submit Request
                  </> : <>
                    {nextStep!.label}
                    <ChevronRightIcon className="w-5 h-5" data-id="element-7386" data-mp="c6guvzrswxhk" />
                  </>}
              </button>
            </div>;
      })()}
        <MobileFooterNav data-id="element-7387" data-mp="lzfknkz1au2r" />
        <PharmacistChat data-id="element-7388" data-mp="lz65ksfj27bu" />
        {/* Spacer for sticky bottom action + mobile footer nav */}
        <div className="h-32 md:hidden" data-id="element-7389" data-mp="pzgd49iyx5st"></div>
        {/* Location Modal */}
        <LocationModal isOpen={locationModalOpen} onClose={() => setLocationModalOpen(false)} onSelectLocation={location => {
        setSelectedLocation(location);
        setLocationModalOpen(false);
      }} data-id="element-7390" data-mp="v03yaekimsf4" />
        {/* Prescription Details Modal */}
        {selectedPrescription && <PrescriptionDetailsModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} prescription={selectedPrescription} data-id="element-7391" data-mp="1552gmmb93jza" />}
        {/* Success Modal */}
        {showSuccessModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-7392" data-mp="1srirvxuqd3d5">
            <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center animate-fadeIn" data-id="element-7393" data-mp="1nuioxvt6ggq9">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-7394" data-mp="1j1pjf5pvx4d4">
                <CheckCircleIcon className="w-12 h-12 text-green-600" data-id="element-7395" data-mp="1f0nqf6mk9ojl" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7396" data-mp="2bjv3zcb6rj0h">
                Request Submitted Successfully
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-7397" data-mp="26qigx6m5nk9u">
                Our pharmacist will contact you soon to follow up on your
                request
              </p>
              <button onClick={() => setShowSuccessModal(false)} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition-colors" data-id="element-7398" data-mp="9sky9l0cujqz">
                OK
              </button>
            </div>
          </div>}
      </div>
    </div>;
}